import { render } from "./FetchStatus.vue?vue&type=template&id=34bd688a"
import script from "./FetchStatus.vue?vue&type=script&lang=js"
export * from "./FetchStatus.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__